import { defineStore } from 'pinia'

const APP_TITLE = import.meta.env.VITE_APP_TITLE ?? 'Panel Admin'

export const usePageStore = defineStore('Page', {
  state: () => ({
    title: '',
  }),
  actions: {
    setPageTitle (title: string) {
      this.title = title
      document.title = `${title} | ${APP_TITLE}`
    },
  },
})
